var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransmission(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Transmission_svg__clip0_753_110322)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 8h32v32H8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.183 33.792v-8.99h9.877V14.207a2.507 2.507 0 001.702-2.37 2.506 2.506 0 00-2.504-2.504 2.507 2.507 0 00-2.504 2.503c0 1.1.714 2.035 1.703 2.37V23.2h-8.274v-8.991a2.508 2.508 0 001.703-2.371 2.507 2.507 0 00-2.505-2.503 2.507 2.507 0 00-2.503 2.503c0 1.1.714 2.036 1.702 2.37V23.2h-8.275v-8.991a2.507 2.507 0 001.703-2.371 2.507 2.507 0 00-2.504-2.503A2.507 2.507 0 0012 11.837c0 1.1.714 2.036 1.703 2.37v19.585A2.507 2.507 0 0012 36.162a2.507 2.507 0 002.504 2.505 2.507 2.507 0 002.504-2.504c0-1.1-.714-2.035-1.703-2.37v-8.991h8.275v8.99a2.507 2.507 0 00-1.703 2.37 2.507 2.507 0 002.504 2.505 2.507 2.507 0 002.504-2.504 2.505 2.505 0 00-1.703-2.37zm7.373-21.956c0-.938.764-1.702 1.702-1.702a1.704 1.704 0 010 3.405 1.704 1.704 0 01-1.702-1.703zm-9.878 0a1.704 1.704 0 013.406.001c0 .94-.764 1.703-1.703 1.703a1.705 1.705 0 01-1.703-1.704zm-9.877 0a1.704 1.704 0 013.405 0c0 .94-.763 1.704-1.702 1.704a1.705 1.705 0 01-1.703-1.704zm3.405 24.326c0 .94-.763 1.703-1.702 1.703a1.705 1.705 0 01-1.703-1.703 1.703 1.703 0 013.405.001zm8.175 1.703a1.705 1.705 0 01-1.703-1.703c0-.939.764-1.703 1.703-1.703.939 0 1.703.764 1.703 1.703 0 .94-.764 1.703-1.703 1.703z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.06 33.792V26.47h-1.603v7.322a2.507 2.507 0 00-1.703 2.37 2.507 2.507 0 002.504 2.505 2.507 2.507 0 002.504-2.505c0-1.1-.714-2.034-1.703-2.37zm-.802 4.073a1.704 1.704 0 01-1.702-1.703 1.704 1.704 0 111.702 1.703z",
    fill: "#0E0E0E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Transmission_svg__clip0_753_110322"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(8 8)",
    d: "M0 0h32v32H0z"
  })))));
}
export default SvgTransmission;